var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0482 9.2685C27.0386 9.61213 26.8762 9.87229 26.5611 10.049L8.2249 19.9772C7.99329 20.1011 7.75419 20.1185 7.5076 20.0295C7.38185 19.9817 7.27732 19.9027 7.194 19.7923C7.14009 19.7209 7.09913 19.6295 7.07113 19.5182L5.72271 13.6106L0.783499 13.6395C0.531025 13.6467 0.328823 13.5496 0.176893 13.3484C0.113181 13.264 0.0735536 13.1818 0.0580106 13.1018C0.014883 12.9407 0.0240578 12.7783 0.0855327 12.6147C0.147008 12.4511 0.249161 12.3154 0.391993 12.2076L4.13062 9.38527L21.8267 9.23533L4.05903 6.30529L2.89061 1.14858C2.80926 0.83289 2.90763 0.554788 3.18574 0.314273C3.4616 0.0856418 3.75069 0.0304776 4.05302 0.148781L26.5697 8.59012C26.7075 8.63898 26.8181 8.7186 26.9014 8.82896C26.9994 8.95881 27.0484 9.10532 27.0482 9.2685Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetBlue);
export default __webpack_public_path__ + "static/media/jet-blue.d271477c4d5cdbcd5d9203b0dc71b867.svg";
export { ForwardRef as ReactComponent };